import React from 'react';
import {
  Card,
  CardBody,
  // UncontrolledDropdown,
  // DropdownItem,
  // DropdownToggle,
  // DropdownMenu,
} from 'reactstrap';
import { AreaChart } from '../../components/charts';
import { ThemeColors } from '../../helpers/ThemeColors';

const ChartCard = ({ data, className = '', controls = false, L, title = "", caption = "", yAxesMax = null }) => {
  const labels = data.map(i => i = i.Key)
  const values = data.map(i => i = i.Value)
  const colors = ThemeColors()
  const areaChartData = {
    labels: labels,
    datasets: [
      {
        label: '',
        data: values,
        borderColor: colors.themeColor1,
        pointBackgroundColor: colors.foregroundColor,
        pointBorderColor: colors.themeColor1,
        pointHoverBackgroundColor: colors.themeColor1,
        pointHoverBorderColor: colors.foregroundColor,
        pointRadius: 4,
        pointBorderWidth: 2,
        pointHoverRadius: 5,
        fill: true,
        borderWidth: 2,
        backgroundColor: colors.themeColor1_10,
      },
    ],
  }

  return (
    <Card className={`${className} dashboard-filled-line-chart`}>
      <CardBody style={{flex: 0}}>
        <div className="float-left float-none-xs">
          <div className="d-inline-block">
            <h5 className="d-inline">
              {L[title]?? title}
            </h5>
            {caption && <span className="text-muted text-small d-block">
            {L[caption]?? caption}
            </span>}
          </div>
        </div>
        {controls && (
          <></>
          // <div className="btn-group float-right float-none-xs mt-2">
          //   <UncontrolledDropdown>
          //     <DropdownToggle caret color="primary" className="btn-xs" outline>
          //       {L["admCommunications.thisWeek"]}
          //     </DropdownToggle>
          //     <DropdownMenu right>
          //       <DropdownItem>
          //         {L["admCommunications.thisWeek"]}
          //       </DropdownItem>
          //       <DropdownItem>
          //         {L["admCommunications.thisMonth"]}
          //       </DropdownItem>
          //     </DropdownMenu>
          //   </UncontrolledDropdown>
          // </div>
        )}
      </CardBody>

      <div className="chart card-body pt-0">
        <AreaChart shadow data={areaChartData} yAxesMax={yAxesMax} />
      </div>
    </Card>
  );
};

export default ChartCard;
